import { Button, type ButtonProps } from "@mantine/core";
import { IconBrandDiscordFilled } from "@tabler/icons-react";

export function DiscordButton(
  props: ButtonProps & React.ComponentPropsWithoutRef<"button">,
) {
  return (
    <Button
      leftSection={
        <IconBrandDiscordFilled style={{ color: "rgb(88, 101, 242)" }} />
      }
      variant="default"
      {...props}
    />
  );
}
